export default __webpack_public_path__ + "3ec1192e95c23999988da23d66c4fa53.png";